import { Component, OnInit, SkipSelf } from '@angular/core';
import { ControlContainer } from '@angular/forms';
import { SimulationDao } from '@app/dao/simulation/simulation.dao';
import { FormControlOption } from '@app/forms/subscription/definition/interface/formControlOption.interface';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import {
  forgetUnavailablePackChoice,
  productParameters,
  pledgeProductHasPacks,
} from '../../../../pledge-pack-choice';

@UntilDestroy()
@Component({
  selector: 'arbitrage-investment-allocation',
  templateUrl: './arbitrage-investment-allocation.component.html',
  styleUrls: ['./arbitrage-investment-allocation.component.scss'],
  viewProviders: [
    {
      provide: ControlContainer,
      useFactory: (container: ControlContainer) => container,
      deps: [[new SkipSelf(), ControlContainer]],
    },
  ],
  standalone: false,
})
export class ArbitrageInvestmentAllocationComponent implements OnInit {
  freeOption: FormControlOption = {
    label: 'Choix libre',
    value: 'FREE',
    suffix: 'A',
    svg: 'free-choice.svg',
  };
  packOption: FormControlOption = {
    label: 'Allocation type',
    value: 'PACK',
    suffix: 'B',
    svg: 'package-choice.svg',
  };
  options: FormControlOption[] = [this.freeOption];

  constructor(
    private simulationDao: SimulationDao,
    private subscriptionFacade: SubscriptionFacadeService,
    private controlContainer: ControlContainer,
  ) {}

  ngOnInit() {
    const pledge = this.subscriptionFacade.getPledge();
    pledgeProductHasPacks(this.simulationDao, pledge)
      .pipe(untilDestroyed(this))
      .subscribe(hasPacks => {
        if (hasPacks) {
          this.options = [this.freeOption, this.packOption];
        } else if (hasPacks === false) {
          forgetUnavailablePackChoice(
            this.controlContainer.control,
            'arbitrageDistribution',
            this.subscriptionFacade,
            productParameters,
          );
        }
      });
  }
}
